import { useMutation } from "@tanstack/react-query";
import { RestEndpoints } from "../../../api/endpoints";
import getInstance from "../../../utils/rest";

interface IDownloadReportingExportParams {
  contractNo: string;
  startReportingNo: number;
  endReportingNo: number;
  lang: "de" | "en";
}

const downloadReportingExport = async (params: IDownloadReportingExportParams): Promise<void> => {
  const { contractNo, startReportingNo, endReportingNo, lang } = params;
  const response = await getInstance().get(
    `${RestEndpoints.PomReportings}/${contractNo}/export?startReportingNo=${startReportingNo}&endReportingNo=${endReportingNo}&lang=${lang}`,
    { responseType: "blob" }
  );
  const disposition = response.headers["content-disposition"] as string | undefined;
  const filenameMatch = disposition?.match(/filename="?([^"]+)"?/);
  const filename = filenameMatch?.[1] ?? `export_${contractNo}_${startReportingNo}-${endReportingNo}.xlsx`;
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const useDownloadReportingExportMutation = () => {
  return useMutation({
    mutationFn: (params: IDownloadReportingExportParams) => downloadReportingExport(params),
  });
};
